export const GET_PLANWITHDRAWABLE_ABORTED = 'GET_PLANWITHDRAWABLE_ABORTED';
export const GET_PLANWITHDRAWABLE_REQUESTED = 'GET_PLANWITHDRAWABLE_REQUESTED';
export const GET_PLANWITHDRAWABLE_COMPLETED = 'GET_PLANWITHDRAWABLE_COMPLETED';
export const GET_PLANWITHDRAWABLE_FAILED = 'GET_PLANWITHDRAWABLE_FAILED';
export const GET_PLANWITHDRAWABLE_RESET = 'GET_PLANWITHDRAWABLE_RESET';

export const ADD_PLANWITHDRAWABLE_FORMDATA_REQUESTED =
  'ADD_PLANWITHDRAWABLE_FORMDATA_REQUESTED';
export const ADD_PLANWITHDRAWABLE_FORMDATA_COMPLETED =
  'ADD_PLANWITHDRAWABLE_FORMDATA_COMPLETED';
export const ADD_PLANWITHDRAWABLE_FORMDATA_FAILED =
  ' ADD_PLANWITHDRAWABLE_FORMDATA_FAILED';
export const SUBMIT_WITHDRAWAL_REQUESTED = 'SUBMIT_WITHDRAWAL_REQUESTED';
export const SUBMIT_WITHDRAWAL_FAILED = 'SUBMIT_WITHDRAWAL_FAILED';
export const SUBMIT_WITHDRAWAL_COMPLETED = 'SUBMIT_WITHDRAWAL_COMPLETED';

export const ATTEMPT_WITHDRAWAL_REQUESTED = 'ATTEMPT_WITHDRAWAL_REQUESTED';
export const ATTEMPT_WITHDRAWAL_FAILED = 'ATTEMPT_WITHDRAWAL_FAILED';
export const ATTEMPT_WITHDRAWAL_COMPLETED = 'ATTEMPT_WITHDRAWAL_COMPLETED';
